export const profile = {
  personalInfo: "Informations personnelles",
  fullName: "Nom complet",
  email: "Adresse e-mail",
  createdAt: "Date de création",
  editTitle: "Modifier les informations personnelles",

  // BankInfoTab
  addBank: "Ajouter une banque",
  selected: "Sélectionné",
  bankName: "Nom de la banque",
  iban: "IBAN",
  bic: "BIC",
  rib: "RIB",
  notProvided: "Non renseigné",

  // CompanyDetails
  companyInfo: "Informations de l'entreprise",
  companyName: "Nom de l'entreprise",
  ownerName: "Propriétaire",
  companyEmail: "Email entreprise",
  phone: "Téléphone",
  address: "Adresse",
  paymentMethod: "Méthode de paiement",
  noPaymentMethod: "Aucune méthode de paiement définie.",
  note: "Note",
  noNote: "Aucune note n'a été ajoutée pour l'instant.",
  companyDocuments: "Documents de l'entreprise",
  viewDownload: "Voir / Télécharger",
  kbis: "KBIS",
  urssaf: "URSSAF",
  fiscale: "Fiscale",
  rcPro: "RC Pro",
  extraFile: "Fichier supplémentaire",
  noDocuments: "Aucun document disponible.",

  // PackInfoTab
  packInfo: "Informations du pack",
  packName: "Nom du pack",
  description: "Description",
  price: "Tarif",
  duration: "Durée",
  status: "Statut",
  active: "Actif",
  inactive: "Inactif",
  timeLeft: "Temps restant",
  expired: "Expiration dépassée",
  notAvailable: "Non disponible",
  urgent: "Urgent",

  // CompanyConfig specific
  tabs: {
    info: "Informations",
    bank: "Banque",
    pack: "Pack",
  },
  loadingUser: "Chargement de l'utilisateur...",
  errorUser: "Erreur lors du chargement de l'utilisateur",
  loadingBanks: "Chargement des banques...",
  errorBanks: "Erreur lors du chargement des banques",
  noBanks: "Aucune information bancaire disponible",
  deleteConfirmation: "Êtes-vous sûr de vouloir supprimer cette banque ?",
  deleteWarningTitle: "Avertissement",
  deleteWarningMessage:
    "Vous essayez de supprimer la banque sélectionnée ! Veuillez d'abord sélectionner une autre banque avant de la supprimer.",
  close: "Fermer",
  enabled: "Activé",
  disabled: "Désactivé",
};
